import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { IonicModule } from '@ionic/angular';
import { UpgradeFormComponent } from './upgrade-form.component';

@NgModule({
  declarations: [UpgradeFormComponent],
  imports: [
    MatSelectModule,
    CommonModule,
    FormsModule,
    IonicModule
  ],
  exports: [UpgradeFormComponent]
})

export class UpgradeFormModule {}
